import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import styled from 'styled-components';
import { WEB_FONT_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import Small from 'UIComponents/elements/Small';
const FullscreenModalHeadingWrapper = styled.h2.withConfig({
  displayName: "FullscreenModalHeading__FullscreenModalHeadingWrapper",
  componentId: "sc-1isrerc-0"
})(["font-size:24px;font-weight:", ";margin-bottom:8px;padding:0 24px;"], WEB_FONT_BOLD_WEIGHT);
export default function FullscreenModalHeading({
  title,
  subtitle
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FullscreenModalHeadingWrapper, {
      tabIndex: 0,
      children: title
    }), subtitle && /*#__PURE__*/_jsx(Small, {
      children: subtitle
    })]
  });
}